import { connect } from "react-redux";
import QrScanPage from "../components/CarerApp/QrScanPage";
import { mapStateToProps, mapDispatchToProps } from "./CarerAppContainer";

export default connect(mapStateToProps, mapDispatchToProps)(QrScanPage);
